import React, { useState, useEffect } from 'react';
import { supabase } from './supabase';
const API = process.env.REACT_APP_API_URL || '';
// [quota-bars] 订阅额度条：Claude Max 的 5 小时窗和 7 天窗，后端 60 秒缓存，这里进页拉一次、可手动刷新
function QuotaBars() {
  const [q, setQ] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true);
    try { const r = await fetch(`${API}/api/usage/subscription`); setQ(await r.json()); }
    catch (e) { setQ({ ok: false, error: String(e && e.message || e) }); }
    setBusy(false);
  };
  useEffect(() => { load(); }, []);
  const fmtReset = (iso) => {
    if (!iso) return '';
    const d = new Date(iso); const ms = d - Date.now();
    if (ms <= 0) return '\u5df2\u91cd\u7f6e';
    const h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
    const when = d.toLocaleString('zh-CN', { timeZone: 'Asia/Hong_Kong', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
    return (h >= 24 ? Math.floor(h / 24) + ' \u5929 ' + (h % 24) + ' \u5c0f\u65f6' : h + ' \u5c0f\u65f6 ' + m + ' \u5206') + '\u540e\u91cd\u7f6e\uff08' + when + '\uff09';
  };
  const bar = (label, w) => {
    const pct = w && typeof w.used_pct === 'number' ? Math.max(0, Math.min(100, w.used_pct)) : null;
    const color = pct === null ? '#999' : pct >= 90 ? '#d9534f' : pct >= 70 ? '#e0a040' : '#c4967e';
    return (
      <div style={{ marginBottom: 10 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, marginBottom: 4 }}>
          <span style={{ color: 'var(--text2, #666)' }}>{label}</span>
          <span style={{ color, fontWeight: 600 }}>{pct === null ? '\u2014' : pct.toFixed(0) + '%'}</span>
        </div>
        <div style={{ height: 6, borderRadius: 3, background: 'rgba(128,128,128,0.18)', overflow: 'hidden' }}>
          <div style={{ width: (pct || 0) + '%', height: '100%', background: color, borderRadius: 3, transition: 'width .4s' }} />
        </div>
        <div style={{ fontSize: 10, color: 'var(--text3, #999)', marginTop: 3 }}>{w ? fmtReset(w.resets_at) : ''}</div>
      </div>
    );
  };
  const d = q && q.ok ? q : (q && q.stale) ? q.stale : null;
  return (
    <div style={{ padding: '12px 16px', borderRadius: 12, border: '1px solid rgba(196,150,126,0.5)', background: 'rgba(196,150,126,0.06)', marginBottom: 14, fontFamily: "'Noto Serif SC', Georgia, serif" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: '#c4967e' }}>{'\u8ba2\u9605\u989d\u5ea6'}{d && d.plan ? ' \u00b7 ' + d.plan : ''}</span>
        <button onClick={load} disabled={busy} style={{ background: 'none', border: '1px solid rgba(196,150,126,0.5)', color: '#c4967e', borderRadius: 8, fontSize: 11, padding: '2px 10px', cursor: 'pointer', opacity: busy ? 0.5 : 1 }}>{busy ? '\u2026' : '\u5237\u65b0'}</button>
      </div>
      {!q ? <div style={{ fontSize: 12, color: 'var(--text3, #999)' }}>{'\u8bfb\u53d6\u4e2d\u2026'}</div> : !d ? <div style={{ fontSize: 12, color: '#d9534f' }}>{'\u8bfb\u4e0d\u5230\uff1a' + (q.error || '')}</div> : (
        <>
          {bar('5 \u5c0f\u65f6\u7a97', d.five_hour)}
          {bar('7 \u5929\u7a97', d.seven_day)}
          {q && !q.ok && <div style={{ fontSize: 10, color: '#e0a040' }}>{'\u521a\u624d\u6ca1\u8bfb\u5230\u65b0\u7684\uff0c\u663e\u793a\u7684\u662f\u4e0a\u4e00\u6b21\u7684'}</div>}
        </>
      )}
    </div>
  );
}

function ApiSettings() {
  const [apiKey, setApiKey] = useState('');
  const [baseUrl, setBaseUrl] = useState('https://www.msuicode.com/v1');
  const [model, setModel] = useState('kiro-claude-opus-4-6');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [saved, setSaved] = useState(false);
  const [chatProvider, setChatProvider] = useState('api');
  const [providerSaving, setProviderSaving] = useState(false);
  const [providerToast, setProviderToast] = useState('');
  const [presets, setPresets] = useState([]);
  const [presetName, setPresetName] = useState('');
  const [presetToast, setPresetToast] = useState('');
  const [silasKey, setSilasKey] = useState('');
  const [silasBase, setSilasBase] = useState('');
  const [silasModel, setSilasModel] = useState('');
  const [silasSaving, setSilasSaving] = useState(false);
  const [silasSaved, setSilasSaved] = useState(false);
  const [silasTesting, setSilasTesting] = useState(false);
  const [silasTestResult, setSilasTestResult] = useState(null);

  useEffect(() => { loadSettings(); }, []);

  const loadSettings = async () => {
    try {
      const ps = await fetch(`${API}/api/profile-settings`).then(r => r.json());
      const cp = Array.isArray(ps) ? ps.find(d => d.key === 'chat_provider') : null;
      if (cp && cp.value) setChatProvider(cp.value);
    } catch (e) {}
    const { data } = await supabase.from('settings').select('*');
    if (data) {
      data.forEach(item => {
        if (item.key === 'api_key') setApiKey(item.value);
        if (item.key === 'base_url') setBaseUrl(item.value);
        if (item.key === 'model') setModel(item.value);
        if (item.key === 'silas_api_key') setSilasKey(item.value || '');
        if (item.key === 'silas_base_url') setSilasBase(item.value || '');
        if (item.key === 'silas_model') setSilasModel(item.value || '');
        if (item.key === 'api_presets') { try { var pp = JSON.parse(item.value || '[]'); if (Array.isArray(pp)) setPresets(pp); } catch (e) {} }
      });
    }
    setLoading(false);
  };

  const saveSetting = async (key, value) => {
    await supabase.from('settings').upsert({ key: key, value: value, updated_at: new Date().toISOString() }, { onConflict: 'key' });
  };

  const switchProvider = async (v) => {
    if (v === chatProvider || providerSaving) return;
    setProviderSaving(true);
    setChatProvider(v);
    try {
      const resp = await fetch(`${API}/api/profile-settings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key: 'chat_provider', value: v })
      });
      if (!resp.ok) { console.error('切换线路失败:', resp.status, await resp.text()); setProviderToast('切换失败，看控制台'); }
      else setProviderToast('已切换到 ' + (v === 'claude_code' ? '订阅 · Claude Code' : 'API · 中转站') + '，下一条消息生效');
    } catch (e) { console.error('切换线路失败:', e); setProviderToast('切换失败：' + e.message); }
    setProviderSaving(false);
    setTimeout(function() { setProviderToast(''); }, 2500);
  };

  const savePresets = async (list) => {
    setPresets(list);
    await saveSetting('api_presets', JSON.stringify(list));
  };
  const flashPreset = (msg) => { setPresetToast(msg); setTimeout(function() { setPresetToast(''); }, 2000); };
  const addPreset = async () => {
    var name = presetName.trim();
    if (!name) { flashPreset('先起个名字'); return; }
    if (!apiKey) { flashPreset('当前 API Key 是空的'); return; }
    var list = presets.filter(function(x) { return x.name !== name; });
    list.push({ name: name, api_key: apiKey, base_url: baseUrl, model: model });
    await savePresets(list);
    setPresetName('');
    flashPreset('已存为常用：' + name);
  };
  const applyPreset = async (pz) => {
    setApiKey(pz.api_key); setBaseUrl(pz.base_url); setModel(pz.model);
    setSaving(true);
    await saveSetting('api_key', pz.api_key);
    await saveSetting('base_url', pz.base_url);
    await saveSetting('model', pz.model);
    setSaving(false);
    flashPreset('已套用并保存：' + pz.name);
  };
  const removePreset = async (name) => {
    if (!window.confirm('删除常用配置「' + name + '」？')) return;
    await savePresets(presets.filter(function(x) { return x.name !== name; }));
    flashPreset('已删除：' + name);
  };

  const saveAll = async () => {
    setSaving(true);
    setSaved(false);
    await saveSetting('api_key', apiKey);
    await saveSetting('base_url', baseUrl);
    await saveSetting('model', model);
    setSaving(false);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const saveSilas = async () => {
    setSilasSaving(true);
    setSilasSaved(false);
    await saveSetting('silas_api_key', silasKey);
    await saveSetting('silas_base_url', silasBase);
    await saveSetting('silas_model', silasModel);
    setSilasSaving(false);
    setSilasSaved(true);
    setTimeout(() => setSilasSaved(false), 2000);
  };

  const testSilas = async () => {
    setSilasTesting(true);
    setSilasTestResult(null);
    try {
      const res = await fetch('/api/test', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          api_key: silasKey || apiKey,
          base_url: silasBase || baseUrl,
          model: silasModel || model
        })
      });
      const data = await res.json();
      setSilasTestResult(data.success ? { success: true, message: data.message } : { success: false, message: data.message });
    } catch (e) {
      setSilasTestResult({ success: false, message: e.message });
    }
    setSilasTesting(false);
  };

  const testConnection = async () => {
    setTesting(true);
    setTestResult(null);
    try {
      const res = await fetch('/api/test', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ api_key: apiKey, base_url: baseUrl, model: model })
      });
      const data = await res.json();
      setTestResult(data.success ? { success: true, message: data.message } : { success: false, message: data.message });
    } catch (e) {
      setTestResult({ success: false, message: e.message });
    }
    setTesting(false);
  };

  if (loading) {
    return <div className="api-settings"><div className="api-loading">加载中...</div></div>;
  }

  return (
    <div className="api-settings">
      <div className="api-header">
        <div className="api-title">API 设置</div>
      </div>

      <div className="api-field" style={{ marginBottom: 18 }}>
        <label className="api-label">聊天线路</label>
        <div style={{ display: 'flex', gap: 8 }}>
          {[['claude_code', '订阅 · Claude Code'], ['api', 'API · 中转站']].map(function(p) {
            var on = chatProvider === p[0];
            return (
              <div key={p[0]} onClick={function() { switchProvider(p[0]); }} style={{
                flex: 1, padding: '10px 0', textAlign: 'center', fontSize: 13, cursor: 'pointer', borderRadius: 8,
                fontFamily: "'Noto Serif SC', Georgia, serif", transition: 'all 0.2s', userSelect: 'none',
                border: on ? '1px solid #c4967e' : '1px solid var(--border, #e5e5e5)',
                background: on ? 'rgba(196,150,126,0.10)' : 'transparent',
                color: on ? '#c4967e' : 'var(--text3, #999)', fontWeight: on ? 600 : 400,
                opacity: providerSaving ? 0.6 : 1
              }}>{p[1]}</div>
            );
          })}
        </div>
        {providerToast && (
          <div className="api-test-result success" style={{ marginTop: 8 }}>{providerToast}</div>
        )}
        <div className="api-hint">
          {chatProvider === 'claude_code'
            ? '走订阅额度，不花 API 的钱，带思维链；朋友圈 / 收藏柜等工具在这条线不动。点一下即生效，下一条消息就走新线。'
            : '走下面配置的中转站，工具全开。点一下即生效。'}
        </div>
      </div>

      <QuotaBars />   {/* [quota-bars] */}
      <div className="api-form">
        {chatProvider === 'claude_code' ? (
          <div style={{ padding: '14px 16px', borderRadius: 12, border: '1px solid #c4967e', background: 'rgba(196,150,126,0.08)', fontFamily: "'Noto Serif SC', Georgia, serif" }}>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#c4967e', marginBottom: 6 }}>当前走订阅线</div>
            <div style={{ fontSize: 12, lineHeight: 1.7, color: 'var(--text3, #999)' }}>
              模型 Opus 4.6，用你的 Claude 订阅额度，不花 API 的钱。人设、记忆、世界书照常注入，思维链可见。<br />
              工具照常可用（朋友圈、收藏柜、玩具、敲门等）；看图类工具暂只在 API 线。<br />
              下面的 Silas 房间始终走 API，与此无关。
            </div>
          </div>
        ) : (
          <>
            <div className="api-field">
              <label className="api-label">API Key</label>
              <input className="api-input" type="password" placeholder="sk-..." value={apiKey} onChange={(e) => setApiKey(e.target.value)} />
            </div>
            <div className="api-field">
              <label className="api-label">Base URL</label>
              <input className="api-input" placeholder="https://api.example.com/v1" value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} />
              <div className="api-hint">填任意兼容 Anthropic 或 OpenAI 格式的 API 地址</div>
            </div>
            <div className="api-field">
              <label className="api-label">模型名称</label>
              <input className="api-input" placeholder="claude-opus-4-6" value={model} onChange={(e) => setModel(e.target.value)} />
              <div className="api-hint">填 API 对应的完整模型名，如 claude-opus-4-6、gpt-4o 等</div>
            </div>

        <div className="api-buttons">
          <button className="api-save-btn" onClick={saveAll} disabled={saving}>
            {saving ? '保存中...' : saved ? '已保存' : '保存'}
          </button>
          <button className="api-test-btn" onClick={testConnection} disabled={testing || !apiKey}>
            {testing ? '测试中...' : '测试连接'}
          </button>
        </div>
        {testResult && (
          <div className={'api-test-result' + (testResult.success ? ' success' : ' fail')}>
            {testResult.success ? '连接成功: ' : '连接失败: '}{testResult.message}
          </div>
        )}

        <div style={{ marginTop: 22, paddingTop: 16, borderTop: '1px dashed #d8cfc6' }}>
          <div className="api-label" style={{ marginBottom: 8 }}>常用配置</div>
          {presets.length === 0 && <div className="api-hint" style={{ marginBottom: 8 }}>还没有。把上面填好的 Key / 中转站 / 模型起个名字存进来，以后一点就换。</div>}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
            {presets.map(function(pz) {
              var host = (pz.base_url || '').replace(/^https?:\/\//, '').split('/')[0];
              var current = pz.api_key === apiKey && pz.base_url === baseUrl && pz.model === model;
              return (
                <div key={pz.name} style={{
                  position: 'relative', flex: '1 1 45%', minWidth: 140, padding: '10px 28px 10px 12px', borderRadius: 10, cursor: 'pointer',
                  border: current ? '1px solid #c4967e' : '1px solid var(--border, #e5e5e5)',
                  background: current ? 'rgba(196,150,126,0.10)' : 'var(--card, #fff)', transition: 'all 0.2s'
                }} onClick={function() { applyPreset(pz); }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: current ? '#c4967e' : 'var(--text, #3d3428)', fontFamily: "'Noto Serif SC', Georgia, serif" }}>{pz.name}</div>
                  <div style={{ fontSize: 11, color: 'var(--text3, #999)', marginTop: 3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{pz.model}</div>
                  <div style={{ fontSize: 10, color: 'var(--text4, #bbb)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{host}</div>
                  <div onClick={function(e) { e.stopPropagation(); removePreset(pz.name); }} title="删除"
                    style={{ position: 'absolute', top: 6, right: 8, fontSize: 16, lineHeight: 1, color: 'var(--text4, #bbb)', padding: 4, cursor: 'pointer' }}>×</div>
                </div>
              );
            })}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <input className="api-input" style={{ flex: 1 }} placeholder="给当前配置起个名字，如：msui 4.8" value={presetName}
              onChange={function(e) { setPresetName(e.target.value); }}
              onKeyDown={function(e) { if (e.key === 'Enter') addPreset(); }} />
            <button className="api-test-btn" style={{ flex: '0 0 auto', padding: '10px 16px' }} onClick={addPreset}>存为常用</button>
          </div>
          {presetToast && <div className="api-test-result success" style={{ marginTop: 8 }}>{presetToast}</div>}
        </div>
          </>
        )}
        <div style={{ marginTop: 28, paddingTop: 18, borderTop: '1px dashed #d8cfc6' }}>
          <div className="api-title" style={{ color: '#8e2f2f', fontSize: 15, marginBottom: 12 }}>{'Silas · 房间二'}</div>
          <div className="api-field">
            <label className="api-label">API Key</label>
            <input className="api-input" type="password" placeholder={'留空 = 跟随上方设置'} value={silasKey} onChange={(e) => setSilasKey(e.target.value)} />
          </div>
          <div className="api-field">
            <label className="api-label">Base URL</label>
            <input className="api-input" placeholder={'留空 = 跟随上方设置'} value={silasBase} onChange={(e) => setSilasBase(e.target.value)} />
          </div>
          <div className="api-field">
            <label className="api-label">{'模型'}</label>
            <input className="api-input" placeholder={'如 claude-opus-5，留空 = 跟随上方'} value={silasModel} onChange={(e) => setSilasModel(e.target.value)} />
            <div className="api-hint">{'三项可单独设，留空的项自动跟随林晏的设置，保存后下一条消息立刻生效'}</div>
          </div>
          <div className="api-buttons">
            <button className="api-save-btn" onClick={saveSilas} disabled={silasSaving}>
              {silasSaving ? '保存中...' : silasSaved ? '已保存' : '保存 Silas 设置'}
            </button>
            <button className="api-test-btn" onClick={testSilas} disabled={silasTesting || (!silasKey && !apiKey)}>
              {silasTesting ? '测试中...' : '测试连接'}
            </button>
          </div>
          {silasTestResult && (
            <div className={'api-test-result' + (silasTestResult.success ? ' success' : ' fail')}>
              {silasTestResult.success ? '连接成功: ' : '连接失败: '}{silasTestResult.message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default ApiSettings;
